import React from 'react';

const RangeInput = (props) => (
  <input type="range" data-name="RangeInput" {...props} />
);

export default RangeInput;
